import { useEffect, useRef, useState } from 'react';
import { containerWidth } from '../../../utils/measuresForResponsiveness';

interface LazyImageProps {
  src: string;
  index: number;
}

export const LazyImage = ({ src, index }: LazyImageProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<SVGGElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { rootMargin: '1000px' }
    );

    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Fallback to load images if they are not intersecting initially
    if (!isVisible) {
      const timeout = setTimeout(() => setIsVisible(true), 3000);
      return () => clearTimeout(timeout);
    }
  }, [isVisible]);
  const calculateHeightG = () => {
    let height = 0;
    if (containerWidth >= 375 && containerWidth < 426) {
      height = 466.7903225806452 - 0.5;
    } else if (containerWidth >= 426 && containerWidth < 768) {
      height = 543.1741935483871 + 1;
    } else if (containerWidth >= 768 && containerWidth < 1024) {
      height = 973.1870967741935 + 2;
    } else if (containerWidth >= 1024) {
      height = 1357 + 3;
    } else {
      height = 401.7225806451613;
    }
    return height;
  };
  const calculateHeight = calculateHeightG();
  return (
    <g
      key={`${index}-group`}
      transform={`matrix(1, 0, 0, 1, 0, ${index * calculateHeight})`}
    >
      {isVisible && (
        <image
          key={index}
          display="block"
          xlinkHref={src}
          width="960"
          height="1357"
        />
      )}
    </g>
  );
};
